import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
    View,
    StyleSheet
} from 'react-native';

import {
    JDTouchable,
    JDText,
    JDImage
} from '@jdreact/jdreact-core-lib';

import img from '../../common/img';

import { pt } from '../../common/utils';
import { get } from '../../common/fetch';

class SeeTomorrow extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        let { contentText } = this.props;
        return (
            <View style={st.see_tomorrow_wrap}>
                <JDImage style={st.no_cinema_icon} source={img.no_cinema}></JDImage>
                <JDText style={st.see_tomorrow_text}>{ contentText }</JDText>
            </View>
        )
    }

    componentDidMount() {
    }
}

const st = StyleSheet.create({
    see_tomorrow_wrap: {
        alignItems: 'center',
        paddingTop: pt(42),
        paddingBottom: pt(10)
    },
    no_cinema_icon: {
        width: pt(78),
        height: pt(74)
    },
    see_tomorrow_text: {
        fontSize: pt(13),
        color: '#252525',
        marginTop: pt(14),
        marginBottom: pt(25)
    }
});

SeeTomorrow.contextTypes = {
    router: PropTypes.object
};

export default SeeTomorrow;